import { useFeatureFlag } from "@app/shared/hooks/use-feature-flag";
import {
  platformFeaturesAtom,
  settingsAtom,
} from "@framework/shared/atoms";
import { useState } from "react";

export type LoginMode = "password" | "qr" | "telegram";

/**
 * Coordinate the available tenant login methods and the active login panel.
 *
 * @example
 * const loginPage = useLoginPage();
 */
export function useLoginPage() {
  const [mode, setMode] = useState<LoginMode>("password");
  const isTelegramEnabled = useFeatureFlag("telegram");
  const platformFeatures = platformFeaturesAtom.useValue();
  const isQrLoginEnabled =
    platformFeatures.qrLogin === true &&
    settingsAtom.use("account")?.qrLoginEnabled === true;
  const accountSettings = settingsAtom.use("account");
  const isPasskeyLoginEnabled =
    platformFeatures.passkeyLogin === true &&
    (accountSettings?.passkeyLoginEnabled === true ||
      accountSettings?.requirePasskeyOnRegistration === true);

  return {
    isPasskeyLoginEnabled,
    isQrLoginEnabled,
    isTelegramEnabled,
    mode,
    showPasswordLogin: () => setMode("password"),
    showQrLogin: () => setMode("qr"),
    showTelegramLogin: () => setMode("telegram"),
  };
}
